import { render, staticRenderFns } from "./login-modal.vue?vue&type=template&id=6a96dfb8&"
import script from "./login-modal.vue?vue&type=script&lang=js&"
export * from "./login-modal.vue?vue&type=script&lang=js&"
import style0 from "./login-modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports